import { Box } from '@mui/material';
import { RenderBlockProps } from '@orgnc/core/components/blocks/Blocks/helpers/RenderBlock';
import Blocks from '@orgnc/core/components/blocks/Blocks';
import {
  StyledMediaTextContainer,
  StyledMediaContainer,
  StyledContentContainer,
} from './core-media-text-style';

const CoreMediaText: React.FunctionComponent<RenderBlockProps> = ({
  block,
}) => {
  const { innerBlocks } = block;
  const {
    mediaAlt,
    mediaPosition = 'left',
    mediaUrl,
    linkTarget,
    href,
    rel,
    linkClass,
    mediaType,
    mediaWidth = 50,
    isStackedOnMobile = true,
    verticalAlignment,
    imageFill = false,
    focalPoint,
    useFeaturedImage = false,
  } = block.attributes;

  // Create media element based on media type
  const renderMedia = () => {
    if (!mediaUrl && !useFeaturedImage) {
      return (
        <Box
          sx={{ backgroundColor: '#f0f0f0', width: '100%', height: '300px' }}
        />
      );
    }

    const mediaElement =
      mediaType === 'video' ? (
        <Box component="video" src={mediaUrl} controls sx={{ width: '100%' }} />
      ) : (
        <Box
          component="img"
          src={mediaUrl}
          alt={mediaAlt || ''}
          sx={{ width: '100%' }}
        />
      );

    if (href) {
      return (
        <Box
          component="a"
          href={href}
          target={linkTarget}
          rel={rel}
          className={linkClass}
        >
          {mediaElement}
        </Box>
      );
    }

    return mediaElement;
  };

  return (
    <StyledMediaTextContainer
      mediaPosition={mediaPosition}
      mediaWidth={mediaWidth}
      verticalAlignment={verticalAlignment}
      isStackedOnMobile={isStackedOnMobile}
    >
      {mediaPosition === 'left' ? (
        <>
          <StyledMediaContainer imageFill={imageFill} focalPoint={focalPoint}>
            {renderMedia()}
          </StyledMediaContainer>
          <StyledContentContainer verticalAlignment={verticalAlignment}>
            <Blocks blocks={innerBlocks} />
          </StyledContentContainer>
        </>
      ) : (
        <>
          <StyledContentContainer verticalAlignment={verticalAlignment}>
            <Blocks blocks={innerBlocks} />
          </StyledContentContainer>
          <StyledMediaContainer imageFill={imageFill} focalPoint={focalPoint}>
            {renderMedia()}
          </StyledMediaContainer>
        </>
      )}
    </StyledMediaTextContainer>
  );
};

export default CoreMediaText;
